// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "calendar-" + chunkId + ".js?v=" + {"node_modules_nextcloud_vue_dist_Components_NcColorPicker_mjs":"2ce30158ffbd1ca3098c","node_modules_nextcloud_vue_dist_Components_NcSelect_mjs":"7cd9faaa5a6c7517f54c","vendors-node_modules_rehype-highlight_index_js":"9a1aa4e77ec802149729"}[chunkId] + "";
};